module.exports = __webpack_public_path__ + "img/circle.f264cfa9.png";